import { render } from "./password.vue?vue&type=template&id=50ee4288&scoped=true"
import script from "./password.vue?vue&type=script&lang=ts"
export * from "./password.vue?vue&type=script&lang=ts"

import "./password.vue?vue&type=style&index=0&id=50ee4288&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-50ee4288"

export default script